import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../../app/route/RoutesConfig";
import { pickupSelector, resetPickupState } from "../../../../slices/pickup/pickupSlice";
import { StepProps } from "../../../../app/data/common/models";
import { formatAddress } from "../../../../services/common/address";
import Button, { ButtonSizes, ButtonThemes } from "../../../../ui-components/button/button";
import { copyTextToClipboard } from "../../../../hooks/utils";
import { ReactComponent as CopyIcon } from "../../../../images/copy.svg";
import "../../../../sass/blocks.scss";

interface PickupSuccessStepProps extends StepProps {
  onStartNewPickup: () => void;
}

const PickupSuccessStep: React.FC<PickupSuccessStepProps> = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const pickupState = useSelector(pickupSelector);

  const onComplete = () => {
    dispatch(resetPickupState());
    props.onStartNewPickup();
    history.push(Routes.pickup.management);
  };

  const onNewPickup = () => {
    dispatch(resetPickupState());
    props.onStartNewPickup();
    props.push("pickup-shipper-step");
  };

  return (
    <div className="xgs-pickup__success-step">
      <div className="xgs-pickup__content-block">
        <div className="xgs-pickup__details-item">
          <div className="xgs-pickup__step-header">Success!</div>
          <div>New pickup has been created</div>
        </div>
        <div className="xgs-pickup__details-item xgs-pickup__details-item--flex">
          <span className="xgs-pickup__pickup-number">{pickupState.pickupNumber}</span>
          <Button
            theme={ButtonThemes.gray}
            size={ButtonSizes.autoMedium}
            onClick={() => copyTextToClipboard(pickupState.pickupNumber)}
          >
            <div className="xgs-btn__icon-container">
              <CopyIcon className="xgs-btn__icon" />
            </div>
            Copy
          </Button>
        </div>
        <div className="xgs-pickup__details-item">
          <div className="xgs-pickup__details-item-label">Time of Availability:</div>
          <div>{`${pickupState.pickupReadyTime} - ${pickupState.pickupCloseTime} ${pickupState.pickupDate}`}</div>
        </div>
        <div className="xgs-pickup__details-item">
          <div className="xgs-pickup__details-item-label">Pickup Address</div>
          <div>{formatAddress(pickupState.shipper.address)}</div>
          <div>{pickupState.shipper.address.additionalAddressLine}</div>
        </div>
        <div className="xgs-pickup__details-item">
          <div className="xgs-pickup__details-item-label">Probill Number</div>
          <div>{pickupState.probillNumber}</div>      
        </div>   
      </div>
      <div className="xgs-pickup__buttons">
        <Button
          type="button"
          theme={ButtonThemes.blue}
          onClick={onComplete}
        >
          Assign to Driver
        </Button>
        <Button
          type="button"
          theme={ButtonThemes.gray}
          onClick={onNewPickup}
        >
          Create new pickup
        </Button>
      </div>
    </div>
  );
};

export default PickupSuccessStep;
